export enum FILTER_TYPE {
  BROWSER = 'browser',
  CAMPAIGN = 'campaign',
  CONNECTION_TYPE = 'connectionType',
  COUNTRY = 'country',
  DEVICE = 'device',
  HOURS = 'hours',
  OFFER = 'offer',
  OS = 'os',
  PROVIDER = 'provider',
  REGION = 'region',
  CITY = 'city',
  TIMEZONE = 'timezone',
  WEEK_DAYS = 'weekDays',
  REPORT_STATUS = 'reportStatus',
  SITE_ID = 'siteId',
  ARCHIVED_STATUS = 'archivedStatus',
}
